import { LocationStrategy } from '@angular/common';
import { Directive, ElementRef, HostListener, inject, input, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InMemoryRouterService } from './in-memory-router.service';

@Directive({
  selector: '[efGenericLink]',
  standalone: true,
})
export class GenericLinkDirective implements OnInit {
  public readonly link = input<string>('', { alias: 'efGenericLink' });

  private readonly router = inject(Router, { optional: true });
  private readonly locationStrategy = inject(LocationStrategy, { optional: true });
  private readonly activatedRoute = inject(ActivatedRoute, { optional: true });
  private readonly memoryRouter = inject(InMemoryRouterService);
  private readonly renderer = inject(Renderer2);
  private readonly elRef = inject(ElementRef);

  public ngOnInit(): void {
    if (this.activatedRoute && this.router && this.locationStrategy) {
      const url = this.router.createUrlTree([this.link()]).toString();
      const urls = this.locationStrategy.prepareExternalUrl(url);
      this.renderer.setAttribute(this.elRef.nativeElement, 'href', urls.toString());
    } else {
      this.renderer.setStyle(this.elRef.nativeElement, 'cursor', 'pointer');
    }
  }

  @HostListener('click', ['$event'])
  public onClick(e: MouseEvent): void {
    e.preventDefault();
    e.stopPropagation();

    if (this.activatedRoute && this.router) {
      this.router.navigateByUrl(this.link());
    } else {
      this.memoryRouter.setView(this.link());
    }
  }
}
